import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button, Heading, Text } from "@nbs/ui";

export function UnauthorizedPage() {
  const { t } = useTranslation();
  return (
    <section className="nbs-page-state">
      <span className="nbs-bare__glyph" aria-hidden="true">
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="8" r="4" stroke="currentColor" strokeWidth="1.6" />
          <path
            d="M4 20c0-3.9 3.6-6 8-6s8 2.1 8 6"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
          />
        </svg>
      </span>
      <Heading level={1}>{t("pages.unauthorizedTitle")}</Heading>
      <Text tone="muted">{t("pages.unauthorizedBody")}</Text>
      <div className="nbs-login-page__actions">
        <Link to="/login">
          <Button variant="primary">{t("nav.login")}</Button>
        </Link>
        <Link to="/">
          <Button variant="secondary">{t("pages.goHome")}</Button>
        </Link>
      </div>
    </section>
  );
}
